import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';

export const StyledContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        padding: ${theme.tggSpacing([rem(2), rem(1.5)], [3, 6])};
        text-align: center;
        background-color: ${theme.getRebrandingColor(
            theme.palette.grey[100],
            theme.palette.tgg.surface.main,
        )};
        border-bottom: ${theme.tggSpacing(rem(0), 0.25)} solid ${theme.palette.tgg.border.rule.main};

        h1 {
            color: ${theme.palette.common.blue};
        }
        .MuiTypography-h1Rebrand {
            color: ${theme.palette.tgg.text.heading.brand};
        }

        ${theme.breakpoints.between('desktop', 1024)} {
            padding: ${theme.tggSpacing([rem(2), rem(1.5)], [3, 12])};
        }
        ${theme.breakpoints.up(1024)} {
            padding: ${theme.tggSpacing([rem(2), rem(1.5)], [3, 20])};
        }
    `}
`;
